export default __webpack_public_path__ + "static/media/logo_flutter.da598ca7.svg";